import axios from "axios";

// ─── DEDICATED AXIOS INSTANCE ───────────────────────────────────────────────
// Creates a dedicated instance instead of mutating axios.defaults.baseURL,
// preventing conflicts with any third-party libraries that also use axios.
// El fallback es por tenant (Mallco Chapi): al cambiar de tenant, ajustarlo
// igual que VITE_API_URL en .env.production.
const httpClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? "https://soportebo.com/api/v1",
});

// ─── REQUEST INTERCEPTOR ────────────────────────────────────────────────────
// Attach the bearer token to every request. Always return config so that
// unauthenticated requests (e.g. /user/login, /user/register) are not blocked.
httpClient.interceptors.request.use(
  (config) => {
    const token = window.localStorage.getItem("token_seguridad");
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }
    return config; // ✅ Always return config
  },
  (error) => Promise.reject(error)
);

// ─── RESPONSE INTERCEPTOR ───────────────────────────────────────────────────
// Intercept 401 Unauthorized responses. When the token is expired or invalid,
// clean up the stored token and force a redirect to the login page.
// Skip this behavior for the login endpoint itself to prevent redirect loops.
httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginEndpoint = error.config?.url?.includes("/user/login");
    const skipRedirect = error.config?.skipAuthRedirect === true;

    if (error.response?.status === 401 && !isLoginEndpoint && !skipRedirect) {
      window.localStorage.removeItem("token_seguridad");
      window.location.replace("/auth/login");
    }
    return Promise.reject(error);
  }
);

const requestGenerico = {
  getOnly: (url) => httpClient.get(url),
  getOnlyWithConfig: (url, config) => httpClient.get(url, config),
  get: (url, parameter) =>
    httpClient.get(url, {
      params: { id: parameter },
    }),
  getWithConfig: (url, config) => httpClient.get(url, config),
  getByJason: (url, parameters) => httpClient.get(url, { params: parameters }),
  post: (url, body) => httpClient.post(url, body),
  postPdf: (url, body) => httpClient.post(url, body, { responseType: "blob" }),
  put: (url, body) => httpClient.put(url, body),
  delete: (url) => httpClient.delete(url),
  getPdf: (url, parameter) =>
    httpClient.get(url, {
      params: { id: parameter },
      responseType: "blob",
    }),

  getPdfByDate: (url, fromDate, toDate) =>
    httpClient.get(url, {
      params: { from: fromDate, to: toDate },
      responseType: "blob",
    }),

  getPdfOnly: (url) =>
    httpClient.get(url, {
      responseType: "blob",
    }),

  getByJasonPdf: (url, parameters) =>
    httpClient.get(url, {
      params: parameters,
      responseType: "blob",
    }),
};

export default requestGenerico;
